import { CONFIG_LAYOUTS } from '../constants'
import { ParsedMd, ParsedTr, ParsedLtr, Config, Configuration, ConfigurationLayout, ReportConfig, ParsedVariable, ParsedGoal, ParsedCms } from '../definitions'

import { isReportContent } from './containers'

const isLiteralString = (val: unknown): val is string => typeof val === 'string'
const isTrTag = (val: unknown): val is ParsedTr => !!val && typeof val === 'object' && 'key' in val && typeof (val as ParsedTr).key === 'string'
const isLtrTag = (val: unknown): val is ParsedLtr => !!val && typeof val === 'object' && 'values' in val && typeof (val as ParsedLtr).values === 'object'

const isMdTag = (val: unknown): val is ParsedMd => !!val && typeof val === 'object' && 'isMarkdown' in val && (val as ParsedMd).isMarkdown === true && 'key' in val && typeof (val as ParsedMd).key === 'string'
const isCmsTag = (val: unknown): val is ParsedCms => !!val && typeof val === 'object' && 'isCmsContent' in val && (val as ParsedCms).isCmsContent === true && 'key' in val && typeof (val as ParsedCms).key === 'string'
const isReportConfig = (val: unknown): val is ReportConfig => {
  if (!val || typeof val !== 'object') {
    return false
  }
  const config = val as ReportConfig
  return Array.isArray(config) && config.every(item => isReportContent(item))
}
const isConfig = (val: unknown): val is Config => {
  if (!val || typeof val !== 'object') {
    return false
  }
  const config = val as Config
  return (
    config !== null

  // (!('fields' in config) || isFieldsConfig(config.fields))
  // && (!('report' in config) || isReportConfig(config.report))
  // && (!('configuration' in config) || isConfiguration(config.configuration)).
  )
}

const isConfigurationLayout = (val: unknown): val is ConfigurationLayout =>
  Object.values(CONFIG_LAYOUTS).includes(val as ConfigurationLayout)

const isConfiguration = (val: unknown): val is Configuration => {
  if (!val || typeof val !== 'object') {
    return false
  }
  const config = val as Configuration
  return config.id !== undefined
    && (config.layout === undefined || isConfigurationLayout(config.layout))
    && config.report_endpoints !== undefined
    && Array.isArray(config.report_endpoints)
    && config.report_endpoints.every(endpoint => typeof endpoint === 'object'
      && endpoint.uri !== undefined
      && endpoint.method !== undefined
      && (endpoint.params === undefined || typeof endpoint.params === 'object'))
}

const isHeroOverviewConfiguration = (val: unknown): val is Configuration & { layout: typeof CONFIG_LAYOUTS.HERO_OVERVIEW } =>
  isConfiguration(val) && val.layout === CONFIG_LAYOUTS.HERO_OVERVIEW

const isVariableTag = (val: unknown): val is ParsedVariable => !!val && typeof val === 'object' && 'variable' in val && typeof (val as ParsedVariable).variable === 'string'

const isGoal = (goal: unknown): goal is ParsedGoal => (
  typeof goal === 'object'
  && goal !== null
  && 'key' in goal
  && typeof (goal as ParsedGoal).key === 'string'
)
export {
  isGoal,
  isMdTag,
  isTrTag,
  isLtrTag,
  isCmsTag,
  isLiteralString,
  isConfig,
  isConfiguration,
  isConfigurationLayout,
  isHeroOverviewConfiguration,
  isReportConfig,
  isVariableTag,
}
